export const TORINO_VIDEOS = [{
  src: 'videos/gran-torino-trailer-finger-gun-house-scene.mp4',
  description: 'Finger gun house scene',
}, {
  src: 'videos/gran-torino-trailer-finger-gun-street-scene.mp4',
  description: 'Finger gun street scene',
}, {
  src: 'videos/gran-torino-trailer-get-off-my-lawn-scene.mp4',
  description: 'Get off my lawn scene',
}, {
  src: 'videos/gran-torino-trailer-throwing-ie-user-out-scene.mp4',
  description: 'Throwing IE user out scene',
}];
